import React, { createContext, useContext, useMemo, useEffect, useState } from 'react';
import { COACH_DEFAULT_STATE } from './coachOnboardingSteps';

const KEY = 'coach_onboarding_v1';

const CoachOnboardingContext = createContext(null);

export const CoachOnboardingProvider = ({ children }) => {
    const [state, setState] = useState(() => {
        try {
            const saved = JSON.parse(localStorage.getItem(KEY));
            return { ...COACH_DEFAULT_STATE, ...(saved || {}) };
        } catch {
            return { ...COACH_DEFAULT_STATE };
        }
    });

    useEffect(() => {
        localStorage.setItem(KEY, JSON.stringify(state));
    }, [state]);

    const setStepDone = (step) =>
        setState((s) => (s[step] ? s : { ...s, [step]: true }));

    const resetOnboarding = () => setState({ ...COACH_DEFAULT_STATE });

    const value = useMemo(
        () => ({ state, setStepDone, resetOnboarding }),
        [state]
    );

    return (
        <CoachOnboardingContext.Provider value={value}>
            {children}
        </CoachOnboardingContext.Provider>
    );
};

export const useCoachOnboarding = () => {
    const ctx = useContext(CoachOnboardingContext);
    if (!ctx) throw new Error('useCoachOnboarding must be used within CoachOnboardingProvider');
    return ctx;
};